import { Box } from '@mui/material';
import React from 'react'
import EarningTable from './EarningTable';

const MyEarningData = () => {
    return (
        <Box bgcolor={"#F3F3F3"} height={"100%"}>
            <EarningTable />
        </Box>
    )
}

export default MyEarningData;
